// extracted by mini-css-extract-plugin
export default {"container":"paginationPage_container__phL9D","buttons":"paginationPage_buttons__K+5Fr","buttonA":"paginationPage_buttonA__auhKI","expandir":"paginationPage_expandir__2oN6Q"};